/**
 * All possible values for aria-autocomplete
 *
 * @export
 * @enum {number}
 * @see {@link https://www.w3.org/TR/wai-aria/#aria-autocomplete WAI-ARIA - aria-autocomplete}
 */
var AutocompleteValue;
(function (AutocompleteValue) {
    AutocompleteValue["INLINE"] = "inline";
    AutocompleteValue["LIST"] = "list";
    AutocompleteValue["BOTH"] = "both";
    AutocompleteValue["NONE"] = "none";
})(AutocompleteValue || (AutocompleteValue = {}));

export { AutocompleteValue as A };
